import React from 'react';
import './Faqs.css';
import FaqList from './FaqList/FaqList'

const Faqs = () => {
    return (
        <section className="faqs-section">
            {/* === FAQ'S heading === */}
            <div className="faqs-section-heading">
                <div className="container">
                    <div className="faqs-heading-content">
                        <h1 className="invisible-title">FAQ'S</h1>
                        <h2 className="heading-title">Frequently Asked Questions</h2>
                        <p className="info">If you have any further questions feel free to email us at contact@elitepartyz.com.au</p>
                    </div>
                </div>
            </div>
            {/* === faqs === */}
            <FaqList />
        </section>
    )
}

export default Faqs
